export const SIGNUP_REGISTER_PATH = 'signup/register';
export const SIGNUP_PLATFORM_PATH = 'signup/platform';
export const PRODUCT_CHOOSE_PATH = 'home';
export const SIGNUP_COMPLETE_PATH = 'signup/complete';
export const MAP_SETUP_PATH = 'install/map';
export const WIDGET_SETUP_PATH = 'install/widget';
export const INTEGRATE_SETUP_PATH = 'install/integrate';
export const INTEGRATE_LAST_STEP_PATH = 'install/integrate/step2';
export const MOBILE_PATH = 'install/mobile';
export const REVIEWS_INSTALLATION_INDICATOR = 'reviews-installation';

export const NAVIGATION_TABS_CUSTOM_EMAILS = 'NAVIGATION_TABS.CUSTOM_EMAILS';
export const NAVIGATION_TABS_CUSTOM_WIDGETS = 'NAVIGATION_TABS.CUSTOM_WIDGETS';
export const NAVIGATION_TABS_INTEGRATE = 'NAVIGATION_TABS.INTEGRATE';
export const NAVIGATION_TABS_ADD_WIDGETS = 'NAVIGATION_TABS.ADD_WIDGETS';

export const STORAGE = { APP_KEY: 'app_key', UTOKEN: 'utoken' };
export const QUERY_PARAMS = { APP_KEY: 'appkey', UTOKEN: 'utoken', PLAN: 'plan' };

export const YOTPO_SUPPORT_PATH = 'https://support.yotpo.com/en/article/shopify-installing-yotpo';
export const OTHER_INSTALLATION_LINK = 'https://support.yotpo.com/en/article/generic-other-platforms-installing-yotpo';
export const VOLUSION_INSTALLATION_LINK   = 'https://support.yotpo.com/en/article/volusion-installing-yotpo';
export const PRESTASHOP_INSTALLATION_LINK = 'https://support.yotpo.com/en/article/prestashop-installing-yotpo';
export const OPENCART_INSTALLATION_LINK   = 'https://support.yotpo.com/en/article/opencart-installing-the-yotpo-star-rating';
export const SFMC_INSTALLATION_LINK   = 'https://support.yotpo.com/en/article/demandware-integration';
export const HYBRIS_INSTALLATION_LINK   = 'https://support.yotpo.com/en/article/generic-other-platforms-installing-yotpo-v1';


export const COMPOSER_LINK = 'https://getcomposer.org/download/';
export const MAGENTO_SETUP_LINK = 'https://support.yotpo.com/en/article/magento-2-installing-yotpo';
export const GENERAL_SETTINGS_LINK = 'https://settings.yotpo.com/#/general_settings';



export const defaultNavItems = [
  { name: NAVIGATION_TABS_CUSTOM_EMAILS, url: MAP_SETUP_PATH, description: 'PANEL.CUSTOMIZATION' },
  { name: NAVIGATION_TABS_CUSTOM_WIDGETS, url: WIDGET_SETUP_PATH, description: 'PANEL.CUSTOMIZATION' },
  { name: NAVIGATION_TABS_INTEGRATE, url: INTEGRATE_SETUP_PATH, description: 'PANEL.INTEGRATION' },
];

export const defaultShopifyNavItems = [
  { name: NAVIGATION_TABS_CUSTOM_EMAILS, url: MAP_SETUP_PATH, description: 'PANEL.CUSTOMIZATION' },
  { name: NAVIGATION_TABS_CUSTOM_WIDGETS, url: WIDGET_SETUP_PATH, description: 'PANEL.CUSTOMIZATION' },
  { name: NAVIGATION_TABS_ADD_WIDGETS, url: INTEGRATE_SETUP_PATH, description: 'PANEL.INTEGRATION' },
];

export const INSTALLATION_FINISH_STATUS = 'Finished';

export const PLANS_PAGE = '#/plans';

let _navItemsPointers = {};
_navItemsPointers[NAVIGATION_TABS_CUSTOM_EMAILS] = {prev: undefined, next: NAVIGATION_TABS_CUSTOM_WIDGETS};
_navItemsPointers[NAVIGATION_TABS_CUSTOM_WIDGETS] = {prev: NAVIGATION_TABS_CUSTOM_EMAILS, next: NAVIGATION_TABS_INTEGRATE};
_navItemsPointers[NAVIGATION_TABS_INTEGRATE] = {prev: NAVIGATION_TABS_CUSTOM_WIDGETS, next: undefined};

export const navItemsPointers = _navItemsPointers;

let _navShopifyItemsPointers = {};
_navShopifyItemsPointers[NAVIGATION_TABS_CUSTOM_EMAILS] = {prev: undefined, next: NAVIGATION_TABS_CUSTOM_WIDGETS};
_navShopifyItemsPointers[NAVIGATION_TABS_CUSTOM_WIDGETS] = {prev: NAVIGATION_TABS_CUSTOM_EMAILS, next: NAVIGATION_TABS_ADD_WIDGETS};
_navShopifyItemsPointers[NAVIGATION_TABS_ADD_WIDGETS] = {prev: NAVIGATION_TABS_CUSTOM_WIDGETS, next: undefined};

export const navShopifyItemsPointers = _navShopifyItemsPointers;
